<div class="text-center">
  <h5 class="text-base mb-0"> {{'ADMIN.PARTNER.NO_PARTNER' | translate}}</h5>
  <button (click)="addModal()" pButton pRipple type="button" icon="fa fa-plus"
  label=" {{ 'ADMIN.PARTNER.CREATE_PARTNER' | translate }}" class="surface-0 p-button-outlined text-sm mt-3 mb-5"></button>
  <div><img src="/assets/img/partner-list-empty.svg" alt="{{ 'ADMIN.PARTNER.CREATE_PARTNER' | translate }}" /></div>
</div>